package com.sddamico.swigmore.ds.poll

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.core.Card
import com.sddamico.swigmore.ds.core.CardVariant
import com.sddamico.swigmore.ds.core.PanelLabel
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeMono
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** One point in a review: [tag] says what the ballot was checked against ("Since last week"). */
data class ReviewNoteView(val tag: String, val text: String)

/**
 * Claude's review of a ballot, on the field: a summary and the notes under it. [stale] says the ballot
 * has changed since, so the notes may no longer apply.
 */
@Composable
fun BallotReviewCard(summary: String, notes: List<ReviewNoteView>, modifier: Modifier = Modifier, note: String = "CLAUDE", stale: Boolean = false) {
  Card(modifier, variant = CardVariant.Field) {
    PanelLabel("Ballot review", note = note)
    if (stale) {
      Div(attrs = Modifier.typeMono("11px").css("color" to SwColor.gold, "margin-bottom" to "8px").toAttrs()) {
        Text("Your ballot has changed since this review.")
      }
    }
    Div(attrs = Modifier.typeBody("15px", 500, "1.5").css("color" to SwColor.text).toAttrs()) { Text(summary) }
    notes.forEach { item ->
      Div(attrs = Modifier.css("padding" to "10px 0 2px", "margin-top" to "10px", "border-top" to "1px solid ${SwColor.hairlineSoft}").toAttrs()) {
        Span(
          attrs = Modifier.typeCaps("9px", ".14em")
            .css("display" to "inline-block", "padding" to "2px 7px", "border-radius" to "10px", "margin-bottom" to "6px",
              "background" to SwColor.tintOnFieldHover, "color" to SwColor.gold)
            .toAttrs()
        ) { Text(item.tag) }
        Div(attrs = Modifier.typeBody("14px", 400, "1.5").css("color" to SwColor.textBody).toAttrs()) { Text(item.text) }
      }
    }
  }
}
